import { render, staticRenderFns } from "./DigitalVoucherSurvey.vue?vue&type=template&id=2ed8ed52&"
import script from "./DigitalVoucherSurvey.vue?vue&type=script&lang=js&"
export * from "./DigitalVoucherSurvey.vue?vue&type=script&lang=js&"
import style0 from "./DigitalVoucherSurvey.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports